import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";

import { Apitoken, Authtoken, role_id, user_location } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const QualityAdd = () => {


  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [primaryCurrency, SetPrimaryCurrency] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('dh');
  const [permission, setPermission] = useState({});

  const [farmLists, setFarmLists] = useState([]);
  const [productLists, setproductLists] = useState([]);
  const [locationLists, setLocationLists] = useState([]);


  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));

  console.log(defaultDate);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const customFuction = (event) => {
    console.log(event);
    setCurrencySymbol(event.label)
  }

  const formik = useFormik({
    initialValues: {
      analysis_name: "",
      product_type: "",
      lab_name: "",
      date: defaultDate,
      farm: "",
      processing_line: "",
      ram_lot_or_farm: "",
      product: "",
      price: "",
      result: "",
      currency: "4",
      file: "",
    },
    onSubmit: (values, { setSubmitting }) => {
      //alert(JSON.stringify(values, null, 2));
      axios
        .post("/qualities/add", values, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {

          delete backendErrors['error'];
          setSubmitting(false);
          // actions.setSubmitting(false);
          $("#form-submit").text("Add Quality");
          if (response.data.code === 200) {
            // setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            //   actions.resetForm();
            setTimeout(() => {
              window.location.href = "/qualities";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    },
  });


  useEffect(() => {
    setPermission(FindModuleById(261));
    console.log(permission);

    axios.get(`/helpers/loading-locations`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
      .then((response) => {
        if (response.data.code === 200) {
          

          let productslisting = response.data.data.locations;

          let locations = productslisting.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `location-${index}`,
          }));

          if (role_id == 0) {

            const filteredData = locations.filter(item => item.value == user_location);
            console.log('filteredData');
            console.log(filteredData);
            setLocationLists(filteredData);
            formik.setFieldValue('processing_line', user_location);
          } else {
            setLocationLists(locations);
            formik.setFieldValue('processing_line', user_location);
          }
          //setLocationLists(locations);

        } else {
          console.log("API response is not an array");
        }
      }).catch((error) => {
        console.log(error);
      });


    axios
      .get(`/helpers/currencies`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let currencies = response.data.data.currencies;
          let currencieslisting = currencies.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farm-${index}`,
          }));
          SetPrimaryCurrency(currencieslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios.post("/farmers/listing", {}, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }
    ).then((response) => {
      if (response.data.code === 200) {
        let orders = response.data.data.farmers;
        let orderslisting = orders.map((customer, index) => ({
          label: customer.name,
          value: customer.id,
          key: `farm-${index}`,
        }));
        setFarmLists(orderslisting);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });

    axios
      .post(
        "/products/listing-groupby",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          // let productslisting = products.map((customer, index) => ({
          //   label: customer.name,
          //   value: customer.name,
          //   key: `prodct-${index}`,
          // }));
          // console.log(productslisting);
          // let other_p = ["Eau d'irrigation","Eau de station","Eau de Ferme","Surface","Sol de ferme"];
          // other_p.map((vall, index) => {
          //       arr =  {
          //         label: vall,
          //         value: vall,
          //         key: `prodct-${index}`,
          //       }
          //     productslisting.push(arr) 
          // });

          // setproductLists(productslisting);
          const productslisting = [
            ...products.map((customer, index) => ({
              label: customer.name,
              value: customer.name,
              key: `product-${index}`,
            })),
            ...["Eau d'irrigation", "Eau de station", "Eau de Ferme", "Surface", "Sol de ferme"].map((vall, index) => ({
              label: vall,
              value: vall,
              key: `other-${index}`, // Different prefix to avoid key collision
            }))
          ];

          console.log(productslisting);
          setproductLists(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }, []);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  let productType = [
    { value: 'Raw Material', label: "Raw Material" },
    { value: 'Finished Product', label: "Finished Product" },
    { value: '-', label: "-" },
  ]
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />  <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Lab Analysis</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/qualities">Lab Analysis</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Lab Analysis</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.add === 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Lab Analysis Info</h4>
                      <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Analysis Name</label>
                                <input
                                  type="text"
                                  name="analysis_name"
                                  value={formik.values.analysis_name}
                                  className="form-input form-control datetimepicker"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.analysis_name && (
                                    <span className="form-error mt-1">
                                      {backendErrors.analysis_name}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Lab Name</label>
                                <input
                                  type="text"
                                  name="lab_name"
                                  value={formik.values.lab_name}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.lab_name && (
                                    <span className="form-error mt-1">
                                      {backendErrors.lab_name}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date</label>
                                <input
                                  type="date"
                                  name="date"
                                  value={formik.values.date}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    setDefaultDate(e.target.value)
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status2">
                                <label>Select Currency</label>
                                <Select

                                  className="w-100"
                                  value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                  name="currency"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("currency", selectedOption);
                                    customFuction(selectedOption);
                                    // handleGetAddressByCustomer(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={primaryCurrency}
                                  placeholder="Select"


                                />

                                <small>
                                  {backendErrors.currency && (
                                    <span className="form-error mt-1">
                                      {backendErrors.currency}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Price</label>

                                <div className="input-group">
                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                        event.preventDefault();
                                      }
                                    }}
                                    name="price"
                                    value={formik.values.price}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Price" aria-label="Price" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.price && (
                                    <span className="form-error mt-1">
                                      {backendErrors.price}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>RM Lot or Farm</label>
                                <input
                                  type="text"
                                  name="ram_lot_or_farm"
                                  value={formik.values.ram_lot_or_farm}
                                  className="form-input  form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.ram_lot_or_farm && (
                                    <span className="form-error mt-1">
                                      {backendErrors.ram_lot_or_farm}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>


                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Product</label>
                                <Select
                                  className="w-100"
                                  value={productLists.find(option => option.value == formik.values.product) || null} // Ensure correct format
                                  name="product"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("product", selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={productLists}
                                  placeholder="Select"


                                />
                                <small>
                                  {backendErrors.product && (
                                    <span className="form-error mt-1">
                                      {backendErrors.product}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Product Type</label>
                                <Select
                                  className="w-100"
                                  value={productType.find(option => option.value == formik.values.product_type) || null} // Ensure correct format
                                  name="product_type"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("product_type", selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={productType}
                                  placeholder="Select"


                                />
                                <small>
                                  {backendErrors.product_type && (
                                    <span className="form-error mt-1">
                                      {backendErrors.product_type}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>File</label>

                                <input
                                  className="form-control"
                                  type="file"
                                  name="file"
                                  onChange={(event) => {
                                    const file_link = event.target.files[0];
                                    //console.log("file:", file_link);
                                    //const fileName = file_link.name;
                                    // const fileName = file_link.name;
                                    const reader = new FileReader();

                                    reader.onloadend = () => {
                                      formik.setFieldValue(
                                        "file",
                                        reader.result
                                      );
                                    };

                                    if (file_link) {
                                      reader.readAsDataURL(file_link);
                                    }
                                  }}
                                />

                                <small>
                                  {backendErrors.file && (
                                    <span className="form-error mt-1">
                                      {backendErrors.file}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Farm</label>
                                <Select
                                  className="w-100"
                                  value={farmLists.find(option => option.value == formik.values.farm) || null} // Ensure correct format
                                  name="farm"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("farm", selectedOption);
                                    // handleGetAddressByCustomer(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={farmLists}
                                  placeholder="Select"


                                />
                                <small>
                                  {backendErrors.farm && (
                                    <span className="form-error mt-1">
                                      {backendErrors.farm}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Processing Line</label>
                                <Select
                                  className="w-100"
                                  value={locationLists.find(option => option.value == formik.values.processing_line) || null} // Ensure correct format
                                  name="processing_line"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("processing_line", selectedOption);
                                    // handleGetAddressByCustomer(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={locationLists}
                                  placeholder="Select"


                                />
                                <small>
                                  {backendErrors.processing_line && (
                                    <span className="form-error mt-1">
                                      {backendErrors.processing_line}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Note</label>
                                <textarea
                                  type="text"
                                  name="result"
                                  value={formik.values.result}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                ></textarea>
                                <small>
                                  {backendErrors.result && (
                                    <span className="form-error mt-1">
                                      {backendErrors.result}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                          </div>


                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                              Add Quality
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityAdd;
